import { FormattedDate } from 'react-intl'
import formatBytes from './bytesFormatter'
import intl from 'app/localization/intl'
import { ReactElement } from 'react'

export type getValueStringValue = string | number | Date | ReactElement
export type getValueStringFormat = 'date' | 'yesno' | 'coordinates' | 'number' | 'size' | 'number-short'

const EMPTY_VALUE = '—' // en dash

export default function getValueString(value?: getValueStringValue, format?: getValueStringFormat) {
  const hasNoValue = value === null || value === undefined || value === ''
  if (hasNoValue) return EMPTY_VALUE

  switch (format) {
    case 'date':
      return <FormattedDate value={value as string | number | Date} year="numeric" month="short" day="numeric" />
    case 'yesno':
      return intl.formatMessage({
        id: value ? 'common.yes' : 'common.no'
      })
    case 'number':
      return Intl.NumberFormat('en-US').format(value as number)
    case 'number-short':
      return Intl.NumberFormat('en-US', {
        maximumFractionDigits: 1,
        minimumFractionDigits: 0,
        notation: 'compact',
        compactDisplay: 'short'
      }).format(value as number)
    case 'coordinates':
      return `${value}`
        .split(',')
        .filter((coord) => !!coord)
        .map((coord) => Math.round(parseFloat(coord) * 10000) / 10000)
        .join(', ')
    case 'size':
      return formatBytes(value as number)
    default:
      return value
  }
}
